export default "__VITE_ASSET__BzJ1tBZD__"